import { getProductUrl } from "@shopware-pwa/helpers-next";

const useMagnoliaShopPages = function () {
  const productPages = useState("productPages", () => ({}));

  /*
   * checks if a url lookup will lead to a default / spare-part pdp
   * */
  const hasConfiguredPdp = (productLike = {}) => {
    const pages = productPages.value ?? {};

    let productPage = pages?.find((page) => {
      return (
        page.productId === (productLike?.id ?? -1) ||
        page.productId === (productLike?.parentId ?? -1) ||
        page.productId === (productLike?.extensions?.containerData?.mainProductId ?? -1)
      );
    });
    return (productPage?.defaultProductPage ?? true) === false;
  };

  /**
   *  getPdpUrlByProduct
   *
   * @param product product-ish Object to find product pages (or variant parents product pages in cms)
   * @param forcePathVariable optional, can be used to enforce a certain id as a part variable (cart links)
   * @returns {string}
   */

  const getPdpUrlByProduct = (productLike = {}, forcePathVariable = null) => {
    // use product id as fallback when seoPathInfo is not available
    let pathVariable = "";
    const pages = productPages.value ?? {};

    if (Object.keys(pages).length === 0) {
      return "";
    }
    let productPage = pages?.find((page) => page.productId === (productLike?.id ?? -1));
    if (!productPage) {
      // no direct id hit means we need shopwares seo url
      pathVariable = productLike?.seoUrls?.[0]?.seoPathInfo ? getProductUrl(productLike) : "";
    }
    if (!productPage) {
      // look for a variants parent
      productPage = pages?.find((page) => page.productId === (productLike?.parentId ?? -1));
    }
    if (!productPage) {
      // lookup configured default pdp
      productPage = pages?.find((page) => page.defaultProductPage === true);
      // if no product page just search the page wirth the shortest url
      if (!productPage) {
        // helper var until proper flag for default
        pages?.forEach((page) => {
          if (
            !productPage ||
            page?.productPageLinkUrl?.length < productPage?.productPageLinkUrl?.length
          ) {
            productPage = page;
          }
        });
      }
      pathVariable = `${productLike?.id ?? productLike?.parentId ?? productLike?.referencedId ?? ""}`;
    }

    let pdpUrl = "";
    if (productPage) {
      // found pdp
      pdpUrl = productPage.productPageLinkUrl;
      if (forcePathVariable) {
        pdpUrl += `/${forcePathVariable}`;
      } else if (pathVariable) {
        pdpUrl += `/${pathVariable}`;
      }

      if (productLike.subscription?.id) {
        // add subscription query param
        pdpUrl += `?subscription=${productLike.subscription?.id}`;
      }
    }
    return pdpUrl.replaceAll("//", "/");
  };

  const getEShopSetUrlByProduct = (product) => {
    // this works for eShopSets because eShopSets cannot be configured for variants
    const setLookupProduct = {
      id: product?.extensions?.containerData?.mainProductId ?? product?.id ?? "",
      parentId: product?.parentId ?? product?.id ?? "",
    };

    const magnoliaProductUrl = getPdpUrlByProduct(setLookupProduct);

    const setOptionIDs = product?.extensions?.eshopSetData?.selectedProducts
      .map((item) => item)
      .join(",");

    return `${magnoliaProductUrl}${setOptionIDs.length > 0 ? `?setOptions=${setOptionIDs}` : ``}`;
  };

  return { productPages, getPdpUrlByProduct, getEShopSetUrlByProduct, hasConfiguredPdp };
};

export default useMagnoliaShopPages;
